import React from 'react';
import {
  Box, Typography, Card, TextField, FormControlLabel, Checkbox, Button,
} from '@mui/material';
import Logo from '../../images/Access1.png';

const LoginForm = () => (
  <Box sx={{
    backgroundColor: '#F5F8FA', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100%',
  }}
  >
    <Card sx={{
      width: '30%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px',
    }}
    >
      <img style={{ width: '180px', height: '70px' }} src={Logo} alt="logo" />
      <Typography component="p" variant="h5" sx={{ fontWeight: '500', fontSize: '30px' }}>Login</Typography>
      <Box component="form">
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <FormControlLabel
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Sign In
        </Button>
      </Box>
    </Card>
  </Box>
);

export default LoginForm;
